import { NgModule } from '@angular/core';
import { HtmlEditorComponent } from './html-editor.component';
import { DxCheckBoxModule, DxHtmlEditorModule, DxSelectBoxModule } from 'devextreme-angular';
import { DxiItemModule, DxoToolbarModule } from 'devextreme-angular/ui/nested';

@NgModule({
    declarations: [
        HtmlEditorComponent,
    ],
    imports     : [
      DxHtmlEditorModule,
      DxCheckBoxModule,
      DxSelectBoxModule,
      DxoToolbarModule,
      DxiItemModule,
    ],
    exports     : [
        HtmlEditorComponent,
    ],
})
export class HtmlEditorModule
{
}
